/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Category,
    CategoryFromJSON,
    CategoryToJSON,
    Design,
    DesignFromJSON,
    DesignToJSON,
    ImageRatio,
    ImageRatioFromJSON,
    ImageRatioToJSON,
} from '../models';

export interface GenerateHashRequest {
    value: string;
    timestamp: string;
}

export interface GetCategoriesRequest {
    sessionId: string;
}

export interface GetDesignsRequest {
    sessionId: string;
    categoryId: string;
    pieceCount: string;
    orientation: string;
    boxType: string;
}

/**
 * no description
 */
export class DesignApi extends runtime.BaseAPI {

    /**
     * get hash to use for loading box images
     * get hash to use for loading box images
     */
    async generateHashRaw(requestParameters: GenerateHashRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.value === null || requestParameters.value === undefined) {
            throw new runtime.RequiredError('value','Required parameter requestParameters.value was null or undefined when calling generateHash.');
        }

        if (requestParameters.timestamp === null || requestParameters.timestamp === undefined) {
            throw new runtime.RequiredError('timestamp','Required parameter requestParameters.timestamp was null or undefined when calling generateHash.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.value !== undefined) {
            queryParameters['value'] = requestParameters.value;
        }

        if (requestParameters.timestamp !== undefined) {
            queryParameters['timestamp'] = requestParameters.timestamp;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/design/hash/generate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * get hash to use for loading box images
     * get hash to use for loading box images
     */
    async generateHash(requestParameters: GenerateHashRequest): Promise<string> {
        const response = await this.generateHashRaw(requestParameters);
        return await response.value();
    }

    /**
     * get visible categories
     * get visible categories
     */
    async getCategoriesRaw(requestParameters: GetCategoriesRequest): Promise<runtime.ApiResponse<Array<Category>>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling getCategories.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/design/categories/{sessionId}`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CategoryFromJSON));
    }

    /**
     * get visible categories
     * get visible categories
     */
    async getCategories(requestParameters: GetCategoriesRequest): Promise<Array<Category>> {
        const response = await this.getCategoriesRaw(requestParameters);
        return await response.value();
    }

    /**
     * get designs for category, piece count, orientation and box type
     * get designs
     */
    async getDesignsRaw(requestParameters: GetDesignsRequest): Promise<runtime.ApiResponse<Array<Design>>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling getDesigns.');
        }

        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling getDesigns.');
        }

        if (requestParameters.pieceCount === null || requestParameters.pieceCount === undefined) {
            throw new runtime.RequiredError('pieceCount','Required parameter requestParameters.pieceCount was null or undefined when calling getDesigns.');
        }

        if (requestParameters.orientation === null || requestParameters.orientation === undefined) {
            throw new runtime.RequiredError('orientation','Required parameter requestParameters.orientation was null or undefined when calling getDesigns.');
        }

        if (requestParameters.boxType === null || requestParameters.boxType === undefined) {
            throw new runtime.RequiredError('boxType','Required parameter requestParameters.boxType was null or undefined when calling getDesigns.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/design/list/{sessionId}/{categoryId}/{pieceCount}/{orientation}/{boxType}`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))).replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters.categoryId))).replace(`{${"pieceCount"}}`, encodeURIComponent(String(requestParameters.pieceCount))).replace(`{${"orientation"}}`, encodeURIComponent(String(requestParameters.orientation))).replace(`{${"boxType"}}`, encodeURIComponent(String(requestParameters.boxType))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DesignFromJSON));
    }

    /**
     * get designs for category, piece count, orientation and box type
     * get designs
     */
    async getDesigns(requestParameters: GetDesignsRequest): Promise<Array<Design>> {
        const response = await this.getDesignsRaw(requestParameters);
        return await response.value();
    }

    /**
     * get image ratios
     * get image ratios
     */
    async getImageRatiosRaw(): Promise<runtime.ApiResponse<Array<ImageRatio>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/design/imageRatios`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ImageRatioFromJSON));
    }

    /**
     * get image ratios
     * get image ratios
     */
    async getImageRatios(): Promise<Array<ImageRatio>> {
        const response = await this.getImageRatiosRaw();
        return await response.value();
    }

}
